export interface OpenInNewTabsResult {
  opened: number;
  blocked: number;
}

/**
 * Opens each URL in its own browser tab, synchronously, so the whole batch
 * runs inside the caller's user-gesture window. Pop-up blockers typically
 * allow only the first tab per gesture until the user allows pop-ups for the
 * site, so callers must surface `blocked` when it is non-zero — the gesture
 * is already spent, so retrying without the user's intervention would be
 * blocked the same way.
 *
 * Each opened tab has its reverse `opener` handle severed — the same
 * protection a static link gets from rel="noopener".
 *
 * @param open injectable opener for tests; defaults to `window.open`.
 */
export function openInNewTabs(
  urls: string[],
  open: (url: string) => Window | null = (url) => window.open(url, '_blank')
): OpenInNewTabsResult {
  let opened = 0;
  let blocked = 0;
  for (const url of urls) {
    const tab = open(url);
    if (tab) {
      tab.opener = null;
      opened++;
    } else {
      blocked++;
    }
  }
  return { opened, blocked };
}
